import styled from '@emotion/styled';
import { devices } from '../../assets/visual/responsive/breakpoints';
import { css } from '@emotion/react';

const viewStyle = props => css`
	justify-content: ${props.align};
	align-items: ${props.align};
	flex-direction: ${props.direction};
`;

const FlexLayout = styled.div`
	${viewStyle}
	@media ${devices.mobileL} {
		height: 80vh;
		flex-direction: column;
	}
	width: 100vw;
	height: 100vh;
	display: flex;
`;

const FlexView = styled.div`
	${viewStyle}
	@media ${devices.mobileL} {
	}
	display: flex;
	flex: 1;
`;

export { FlexLayout, FlexView };
